import RouterApp from "./Routes";
import { FocusProvider } from "./context/FocusContext";
import { AuthProvider } from "./context/AuthContext";

const App = () => {
  return (
    <AuthProvider>
      <FocusProvider>
        <RouterApp />
      </FocusProvider>
    </AuthProvider>
  );
};

export default App;
